module.exports = __webpack_public_path__ + "img/107044.348fe8ab.png";